import React from 'react';

/**
 * The one definition of what a form control looks like in the rewritten screens — auth, account,
 * and the workspace / word list dialogs it was lifted from. Kept in a neutral module because the
 * alternative is the same class string copy-pasted into every form, which is exactly how the old
 * build ended up with three slightly different inputs on three screens.
 */
export const controlClass = 'w-full rounded-lg border border-gray-800 bg-gray-950/60 px-3 py-2 text-sm '
  + 'text-gray-100 placeholder-gray-600 focus:border-indigo-500 focus:outline-none '
  + 'focus:ring-1 focus:ring-indigo-500 disabled:opacity-50';

/** `indigo-600` is the one accent, reserved for the primary action on screen. */
export const primaryButtonClass = 'flex items-center justify-center gap-2 rounded-lg bg-indigo-600 px-3 '
  + 'py-2 text-sm font-medium text-white hover:bg-indigo-500 transition-colors '
  + 'disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer';

export const secondaryButtonClass = 'flex items-center justify-center gap-2 rounded-lg border '
  + 'border-gray-700 px-3 py-2 text-sm font-medium text-gray-200 hover:border-gray-600 '
  + 'hover:bg-gray-800 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer';

/** Render prop for Formik's `<ErrorMessage>`. */
export const fieldError = (msg: string) => <p className="mt-1 text-xs text-red-300">{msg}</p>;

export const Spinner: React.FC = () => (
  <span className="h-3.5 w-3.5 animate-spin rounded-full border-[1.5px] border-current border-t-transparent" />
);
